import React, { useMemo, useState } from 'react';
import FighterList from '../../components/FighterList';

function AdminView() {
    const [activePanel, setActivePanel] = useState('overview'); // overview | create | manage

    const panelTitle = useMemo(() => {
        switch (activePanel) {
            case 'create':
                return 'Create Event';
            case 'manage':
                return 'Manage Events';
            default:
                return 'Overview';
        }
    }, [activePanel]);

    function TabButton({ value, children }) {
        const active = activePanel === value;

        return (
            <button
                type="button"
                onClick={() => setActivePanel(value)}
                style={{
                    minWidth: 0,
                    padding: '0.9rem 1rem',
                    borderRadius: '12px',
                    border: active ? '1px solid transparent' : '1px solid #333',
                    background: active ? 'var(--primary)' : 'rgba(255,255,255,0.02)',
                    color: active ? '#000' : '#fff',
                    fontWeight: 800,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06rem',
                    cursor: 'pointer'
                }}
            >
                {children}
            </button>
        );
    }

    function StatCard({ label, value, description }) {
        return (
            <div
                style={{
                    padding: '1rem',
                    borderRadius: '14px',
                    border: '1px solid #2a2a2a',
                    background: 'rgba(255,255,255,0.02)',
                    textAlign: 'left'
                }}
            >
                <div
                    style={{
                        fontSize: '0.72rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.08rem',
                        color: '#7f7f7f',
                        marginBottom: '0.5rem'
                    }}
                >
                    {label}
                </div>

                <div
                    style={{
                        fontSize: '1.15rem',
                        fontWeight: 800,
                        color: 'var(--primary)',
                        marginBottom: '0.4rem'
                    }}
                >
                    {value}
                </div>

                <div
                    style={{
                        fontSize: '0.9rem',
                        color: '#9a9a9a',
                        lineHeight: 1.45
                    }}
                >
                    {description}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="action-row" style={{ marginBottom: '1rem' }}>
                <div className="cta-text" style={{ width: '100%' }}>
                    <p>Admin Control Panel</p>

                    <div
                        style={{
                            marginTop: '0.8rem',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                            gap: '0.6rem'
                        }}
                    >
                        <TabButton value="overview">Overview</TabButton>
                        <TabButton value="create">Create Event</TabButton>
                        <TabButton value="manage">Manage Events</TabButton>
                    </div>

                    <div
                        style={{
                            marginTop: '0.9rem',
                            color: '#888',
                            fontSize: '0.92rem',
                            lineHeight: 1.5
                        }}
                    >
                        Current section:{' '}
                        <span style={{ color: 'var(--primary)', fontWeight: 700 }}>
                            {panelTitle}
                        </span>
                    </div>
                </div>
            </div>

            {activePanel === 'overview' && (
                <>
                    <div className="action-row" style={{ marginBottom: '1rem' }}>
                        <div className="cta-text" style={{ width: '100%' }}>
                            <p>Administrator</p>
                            <div style={{ fontSize: '1rem', marginTop: '0.6rem' }}>
                                Welcome to the Y Fight control panel.
                            </div>
                            <div className="dim" style={{ marginTop: '0.6rem' }}>
                                Create new events, publish or close them, and manage registrations from one place.
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                            gap: '0.9rem',
                            marginBottom: '1rem'
                        }}
                    >
                        <StatCard
                            label="Create Event"
                            value="New setup"
                            description="Create a new event with registration rules, venue, and schedule."
                        />
                        <StatCard
                            label="Manage Events"
                            value="Publish + close"
                            description="Switch event status, review event details, and keep the platform tidy."
                        />
                        <StatCard
                            label="Registrations"
                            value="Approve + check in"
                            description="Review submitted registrations and manage the live event workflow."
                        />
                    </div>
                </>
            )}

            {activePanel === 'create' && (
                <FighterList mode="create" />
            )}

            {activePanel === 'manage' && (
                <FighterList mode="manage" />
            )}
        </>
    );
}

export default AdminView;